module.exports = __webpack_public_path__ + "static/media/tomb.914786e5.obj";